import React, { JSX } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal } from '../../Store/Actions/modalActions';
import DemoModal from './DemoModal';
import { ModalData } from '../../Types';

function DemoInfoBox(): JSX.Element {
    const i18n = useSelector((state: any) => state.i18n.i18n);
    const dispatch = useDispatch();
    const handleOpenDemoModal = () => {
        dispatch(
            setModal({
                state: 'open',
                title: i18n.translate({
                    id: 'modal.headline',
                    sourceName: 'Demo',
                }),
                modalSize: 'full',
                showLeftButton: false,
                showRightButton: false,
                content: <DemoModal />,
            } as ModalData),
        );
    };

    return (
        <div className="z-[1] relative mb-1 text-layout-textcolor">
            <div className="flex gap-2 justify-center items-center w-fit py-2">
                <div className="bg-primary text-layout-textColorOnPrimary rounded py-1 px-2">
                    {i18n.translate({
                        id: 'demo',
                        sourceName: 'Demo',
                    })}
                </div>
                <div className="font-bold">
                    {i18n.translate({
                        id: 'infoBox.text',
                        sourceName: 'Demo',
                    })}
                </div>
                <div onClick={handleOpenDemoModal} className="underline hover:cursor-pointer hover:no-underline">
                    {i18n.translate({
                        id: 'infoBox.link',
                        sourceName: 'Demo',
                    })}
                </div>
            </div>
        </div>
    );
}

export default DemoInfoBox;
